import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './AppGate';
import './utils/chartSetup';
import './styles/globals.css';
import 'calc-controls/styles.css';
import 'calc-nav/styles.css';
import 'calc-sidebar/styles.css';

registerSW({ onNeedRefresh() {}, onOfflineReady() {} });

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <AppLockProvider>
        <AppGate />
      </AppLockProvider>
    </ErrorBoundary>
  </StrictMode>
);
